import script from "./FinanceSetupSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceSetupSidebar.vue?vue&type=script&setup=true&lang=js"

import "./FinanceSetupSidebar.vue?vue&type=style&index=0&id=34febfa8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34febfa8"]])

export default __exports__